import React, { useEffect, useState } from 'react';
import { listCanvasDespatches } from '../lib/adminApi';

export default function CanvasDespatch() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    listCanvasDespatches()
      .then((data) => setRows(data.despatches || []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="admin-page-header">
        <div>
          <h1>Canvas Despatch</h1>
          <p>Final canvases are archived here and emailed to the customer once a service ends.</p>
        </div>
      </div>

      {error && <div className="admin-alert admin-alert-error">{error}</div>}

      <div className="admin-alert admin-alert-info">
        Automatic generation and emailing ships in a later phase. This module already
        lists real records from the database as they're produced.
      </div>

      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Domain</th>
              <th>Canvas</th>
              <th>Sent To</th>
              <th>Status</th>
              <th>Sent At</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td>{r.projects?.domain_name || '—'}</td>
                <td>{r.projects?.canvas_type || '—'}</td>
                <td>{r.email_sent_to || '—'}</td>
                <td><span className={`admin-badge admin-badge-${r.status === 'sent' ? 'active' : 'pending'}`}>{r.status}</span></td>
                <td>{r.email_sent_at ? new Date(r.email_sent_at).toLocaleString() : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!loading && rows.length === 0 && <div className="admin-empty">Nothing dispatched yet.</div>}
      </div>
    </div>
  );
}
